<h1 class="visually-hidden">{{ 'orders.knowYourCustomerOrder' | transloco }}</h1>
<div class="padding">
  @if (!isLoadingOrder) {
    <div class="flex-container">
      @if (!isLoadingOrder) {
        <div class="flex-item">
          @if (orderId) {
            <div class="padding-sides-15 padding-bottom">
              <mat-card>
                <mat-card-content>
                  <app-base-order-information-review [orderTypeGroupID]="orderTypeGroupID"></app-base-order-information-review>
                </mat-card-content>
              </mat-card>
            </div>
          }
          <div class="padding-sides-15">
            <mat-card>
              <mat-card-content>
                <app-order-stepper
                  [orderId]="orderId"
                  [orderTypeGroupID]="orderTypeGroupID"
                  (promptSubmissionConfirmationEvent)="submissionConfirmation()"
                  (promptDeletionConfirmationEvent)="deletionConfirmation()"
                  (promptCancelConfirmationEvent)="cancelConfirmation()">
                </app-order-stepper>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      }
      <div class="flex-item-fixed-size padding-top margin-right-15 order-fees-sticky min-width-275">
        @if (showOrderFees) {
          <app-order-fees></app-order-fees>
        }
        @if (showOrderFees) {
          <br/>
        }
        <app-order-bundles></app-order-bundles>
        @if (order.orderGroup?.bundles) {
          <br/>
        }
        <mat-card >
          <mat-card-content>
            @if (shouldShowOrderMessages()) {
              <div class="button-container">
                <button mat-flat-button color="primary" class="flex-item-right-align"
                  matBadge="{{messageCount()}}" matBadgeColor="warn"
                (click)="openOrderMessages()">{{ 'common.labels.messages' | transloco }}</button>
              </div>
            }
            @if (showBundlesButton()) {
              <div class="button-container">
                <button mat-flat-button color="primary" class="flex-item-right-align"
                (click)="addToBundle()">{{ 'orders.addToBundle2' | transloco }}</button>
              </div>
            }
            @if (order.orderStatusTypeID == 'Draft' || order.orderStatusTypeID == 'HistoricalDraft') {
              <div class="button-container">
                <button mat-flat-button color="warn" class="flex-item-right-align" [attr.aria-label]="'orders.deleteDraftButton' | transloco"
                (click)="deletionConfirmation()">{{ 'orders.deleteDraft' | transloco }}</button>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  }

  <!-- Spinner (replaces everything and waits until all requests have completed to show anything) -->
  @if (isLoadingOrder) {
    <div class="loading-spinner-overlay">
      <div class="loading-spinner-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  }
</div>
<!-- End of spinner -->